import React from "react";
import { useSSE } from "hooks/useSSE";
import type { SSEEvent } from "hooks/useSSE";

/**
 * Subscribes to SSE and silently refreshes excursion/booking data on
 * any mutation event. actor_id is not filtered so that two tabs of the
 * same user stay in sync without extra complexity.
 *
 * Also listens for billing counter events (`customer_product`,
 * `counter_movement`) so that counter UIs refresh in real time.
 */
export function useExcursionSSE(
  silentReloadExcursions: () => Promise<void>,
  silentReloadBookings: () => Promise<void>,
  silentReloadCounters?: () => Promise<void>,
) {
  const onEvent = React.useCallback(
    (evt: SSEEvent) => {
      switch (evt.entity) {
        case "excursion":
          silentReloadExcursions();
          break;
        case "excursion_booking":
          silentReloadBookings();
          break;
        case "customer_product":
        case "counter_movement":
          silentReloadCounters?.();
          break;
      }
    },
    [silentReloadExcursions, silentReloadBookings, silentReloadCounters],
  );

  useSSE(onEvent);
}
